import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getSupportedFieldConfiguration } from '../../../../../../../../controllers/view-configuration';
export var filterFieldTypeBasedOnScopes = function filterFieldTypeBasedOnScopes(viewType, fieldType, moduleScopes) {
  var _getSupportedFieldCon;
  var fieldRequiredScopes = (_getSupportedFieldCon = getSupportedFieldConfiguration(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.requiredScopes;
  if (!fieldRequiredScopes) {
    return true;
  }
  var includeCoarseScopes = function includeCoarseScopes() {
    return fieldRequiredScopes.coarse.length &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - requiredScope is not types on CI somehow
    fieldRequiredScopes.coarse.every(function (requiredScope) {
      return moduleScopes.includes(requiredScope);
    });
  };
  var includeGranularScopes = function includeGranularScopes() {
    return fieldRequiredScopes.granular.length &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - requiredScope is not types on CI somehow
    fieldRequiredScopes.granular.every(function (requiredScope) {
      return moduleScopes.includes(requiredScope);
    });
  };
  return includeCoarseScopes() || includeGranularScopes();
};
export var filterFormDataBasedOnScopes = function filterFormDataBasedOnScopes(formData, viewType, moduleScopes) {
  var formDataAsArray = Object.entries(formData);
  var filteredFormDataArray = formDataAsArray.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      value = _ref2[1];
    if (!(value !== null && value !== void 0 && value.fieldType)) {
      return false;
    }
    var fieldType = value.fieldType;
    return filterFieldTypeBasedOnScopes(viewType, fieldType, moduleScopes);
  });
  return Object.fromEntries(filteredFormDataArray);
};
export var filterFieldsChangesBasedOnScopes = function filterFieldsChangesBasedOnScopes(fieldsChanges, formData, viewType, moduleScopes) {
  var fieldsChangesAsArray = Object.entries(fieldsChanges);
  var filteredFieldsChangesArray = fieldsChangesAsArray.filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      fieldId = _ref4[0];
    var field = formData[fieldId];
    var fieldType = field === null || field === void 0 ? void 0 : field.fieldType;
    if (!fieldType) {
      return false;
    }
    return filterFieldTypeBasedOnScopes(viewType, fieldType, moduleScopes);
  });
  return Object.fromEntries(filteredFieldsChangesArray);
};